module.exports = __webpack_public_path__ + "img/active.3cff886d.svg";